import PropTypes from 'prop-types';
import React from 'react';
import { actionOnKeyboardPress } from '../utils/browserUtils';

const PRESSED_STATE_DELAY = 100;

class CircleButton extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            pressed: false,
        };
    }

    pointerDown = () => {
        this.setState({ pressed: true });
    };

    pointerUp = () => {
        setTimeout(() => {
            this.setState({ pressed: false });
        }, PRESSED_STATE_DELAY);
    };

    onKeyPress = e => {
        actionOnKeyboardPress(e, () => {
            this.pointerDown();
            this.props.onClick();
        });
    };

    onKeyRelease = e => {
        actionOnKeyboardPress(e, () => {
            this.pointerUp();
        });
    };

    render() {
        const pressedClass = this.state.pressed ? ' pressed' : '';
        return (
            <div className={`circle-btn-wrapper ${this.props.class}`}>
                <button
                    disabled={this.props.isDisabled}
                    aria-label={this.props.ariaLabel}
                    type="button"
                    data-dd-action-name={this.props.class}
                    className={`circle-btn${pressedClass}`}
                    onClick={this.props.onClick}
                    onKeyDown={this.onKeyPress}
                    onKeyUp={this.onKeyRelease}
                    onMouseDown={this.pointerDown}
                    onMouseUp={this.pointerUp}
                    onTouchStart={this.pointerDown}
                    onTouchEnd={this.pointerUp}
                />
            </div>
        );
    }
}

CircleButton.propTypes = {
    onClick: PropTypes.func.isRequired,
    class: PropTypes.string,
    ariaLabel: PropTypes.string.isRequired,
    isDisabled: PropTypes.bool,
};

CircleButton.defaultProps = {
    class: 'circle-button-left',
    isDisabled: false,
};

export default CircleButton;
